﻿import WalletLayout from "~pages/Wallet/components/WalletLayout";
import CreditInfoMenu from "~pages/Wallet/CreditInfo/components/CreditInfoMenu";
import ReceiverFormEdit from "./ReceiverFormEdit";
import { useParams } from "react-router-dom";
import { useConfigureFooter } from "~hooks/useHelpers";
import useHeader from "~components/Header/hooks/useHeader";
import { useEffect, useState } from "react";
import { db } from "~/db/db";
import { useGetClienteCarteira } from "~pages/Wallet/hooks/useWallet";
import { Spinner } from "@chakra-ui/react";

const ReceiverEdit = () => {
  const { parameter: id } = useParams();

  const [backRoute, setBackRoute] = useState(null);
  const [cliente, setCliente] = useState();
  const [loading, setLoading] = useState(true);

  const shouldFetchFromApi = Boolean(id && navigator.onLine);
  const clienteRequest = useGetClienteCarteira(id, shouldFetchFromApi);

  useEffect(() => {
    let isMounted = true;

    const loadCliente = async () => {
      const clienteId = Number.parseInt(id, 10);

      if (!clienteId) {
        if (!isMounted) return;
        setCliente(undefined);
        setLoading(false);
        return;
      }

      if (!navigator.onLine) {
        const clienteLocal = await db.cliente.get(clienteId);
        if (!isMounted) return;
        setCliente(clienteLocal);
        setLoading(false);
        return;
      }

      if (clienteRequest.data) {
        setCliente(clienteRequest.data);
        setLoading(false);
        db.cliente.put(clienteRequest.data).catch(() => null);
        return;
      }

      if (clienteRequest.isError) {
        const clienteLocal = await db.cliente.get(clienteId);
        if (!isMounted) return;
        setCliente(clienteLocal);
        setLoading(false);
        return;
      }

      setLoading(clienteRequest.isLoading || clienteRequest.isFetching);
    };

    loadCliente();

    return () => {
      isMounted = false;
    };
  }, [clienteRequest.data, clienteRequest.isError, clienteRequest.isFetching, clienteRequest.isLoading, id]);

  const recebedorEmissor = [1, 2].includes(cliente?.tipo);

  useEffect(() => {
    if (!loading && !cliente && !navigator.onLine) {
      setLoading(false);
    }
  }, [cliente, loading]);

  useConfigureFooter({ form: true, formId: "recebedor", backRoute, submitLabel: "Atualizar" }, [backRoute]);

  return (
    <WalletLayout>
      {loading ? (
        <div className="py-6 flex justify-center">
          <Spinner />
        </div>
      ) : (
        <>
          <CreditInfoMenu id={id} editSender={recebedorEmissor} />

          <ReceiverFormEdit
            cliente={cliente}
            id={id}
            setBackRoute={setBackRoute}
            recebedorEmissor={recebedorEmissor}
          />
        </>
      )}
    </WalletLayout>
  );
};
export default ReceiverEdit;
